export default __webpack_public_path__ + "static/media/13.00853167.jpg";